import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { SEO_MAP, SEO_BASE, SEO_SITE, OG_IMAGE } from "@/lib/seo";

export default function Seo() {
  const { pathname } = useLocation();
  const meta = SEO_MAP[pathname] || SEO_MAP["/"];
  const url = `${SEO_BASE}${pathname === "/" ? "/" : pathname}`;

  return (
    <Helmet>
      <html lang="it" />
      <title>{meta.title}</title>
      <meta name="description" content={meta.description} />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={url} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SEO_SITE} />
      <meta property="og:locale" content="it_IT" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={meta.title} />
      <meta property="og:description" content={meta.description} />
      <meta property="og:image" content={OG_IMAGE} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={meta.title} />
      <meta name="twitter:description" content={meta.description} />
      <meta name="twitter:image" content={OG_IMAGE} />
    </Helmet>
  );
}
